import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import { useLanguage } from "../../Language";
import { Box, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useAddToListDialog } from "../search/ls/AddToListDialog";
import { useDialog } from "@tlc/ui/dialog/useDialog";
import VirtualShelfDialog from "../account/VirtualShelfDialog";
import { useMenuAnchor } from "@tlc/ui/menu/useMenuAnchor";
import { OverflowMenu } from "@tlc/ui/menu/OverflowMenu";

interface MoreMenuProps {
  resource: ResourceDWR;
}

export default function MoreMenu({ resource }: MoreMenuProps) {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const { showDialog } = useAddToListDialog();
  const {
    open: virtualShelfOpen,
    openDialog: openVirtualShelf,
    closeDialog: closeVirtualShelf,
  } = useDialog();
  const displayVirtualShelf =
    locationConfiguration?.pacSettings?.displaySettings?.displayVirtualShelf;

  if (!displayVirtualShelf) {
    return (
      <IconButton onClick={() => showDialog([resource.id])} color="primary">
        <PlaylistAddIcon />
      </IconButton>
    );
  }

  const menuAnchor = useMenuAnchor("resource-more-button");
  const { closeMenu } = menuAnchor;

  return (
    <Box>
      <OverflowMenu {...menuAnchor} iconOrientaion="vertical" outlined>
        <MenuItem
          onClick={(event) => {
            showDialog([resource.id]);
            closeMenu();
          }}
        >
          <ListItemIcon>
            <PlaylistAddIcon />
          </ListItemIcon>
          <ListItemText>{translate("addToList")}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            openVirtualShelf();
            closeMenu();
          }}
        >
          <ListItemIcon>
            <ViewWeekIcon />
          </ListItemIcon>
          <ListItemText>{translate("virtualShelfButtonText")}</ListItemText>
        </MenuItem>
      </OverflowMenu>
      <VirtualShelfDialog
        resource={resource}
        open={virtualShelfOpen}
        onClose={closeVirtualShelf}
      />
    </Box>
  );
}
